import { createSlice, createSelector } from '@reduxjs/toolkit';

const userDataSlice = createSlice({
    name: 'userDataSliceName',
    initialState: {
        id: null,
        userName: '',
        userEmail: null,
        userToken: null,
        empId: null,
        role_name: null,
        reporting_manager: null,
        employee_id: null,
        refreshCalled: false,
        companyData: {
            company_code: null,
            company_name: null,
            base_url: null
        },
        userPermissions: [],
        isLoading: false,
        backDrop: false,
        lastLoginPage: {
            portal: '/auth',
            customerID: null
        }
    },
    reducers: {
        startCompanyData(state, action) {
            state.isLoading = true;
        },
        setCompanyData(state, action) {
            state.companyData = action.payload;
        },
        startUserLogin(state, action) {
            state.isLoading = true;
        },
        setUserData(state, action) {
            if (action.payload.company_code) {
                state.userToken = action.payload.token;
                state.id = action.payload.user.id;
                state.userName = action.payload.user.name;
                state.userEmail = action.payload.user.email;
                state.empId = action.payload.user.empId;
                state.role_name = action.payload.user.role_name;
                state.reporting_manager = action.payload.user?.reporting_manager
            } else {
                state.userName = action.payload.data;
            }
            state.employee_id = 'admin';
        },
        setUserPermissions(state, action) {
            state.userPermissions = action.payload || [];
        },
        startTogetRefreshToken(state, action) {
            state.isLoading = true;
        },
        startUserLogout(state, action) {
            state.isLoading = true;
        },
        setNullAfterLogout(state, action) {
            state.userName = null;
            state.userEmail = null;
            state.userToken = 'logout';
            state.userPermissions = [];
        },
        setLastLoginPagePortale(state, action) {
            state.lastLoginPage = action.payload;
        },
        setTrueOnRefreshPage(state, action) {
            state.refreshCalled = true;
        },
        completedFetch(state, action) {
            state.isLoading = false;
        },
        userLogout(state, action) {
            return {
                id: null,
                userName: '',
                userEmail: null,
                userToken: null,
                employee_id: null,
                refreshCalled: false,
                companyData: {
                    company_code: null,
                    company_name: null,
                    base_url: null
                },
                userPermissions: [],
                isLoading: false,
                backDrop: false,
                lastLoginPage: {
                    portal: '/auth',
                    customerID: null
                }
            }
        }
    }
});

export const {
    startUserLogin,
    startCompanyData,
    setCompanyData,
    setUserData,
    startUserLogout,
    setNullAfterLogout,
    setTrueOnRefreshPage,
    completedFetch,
    setUserPermissions,
    startTogetRefreshToken,
    userLogout
} = userDataSlice.actions;

export default userDataSlice.reducer;

//selectors
const mainUserState = (state) => state.UserData;

export const isLoadingSelectorUser = createSelector([mainUserState], (UserDataState) => UserDataState.isLoading);
export const usersDataSelector = createSelector([mainUserState], (UserDataState) => {
    return {
        id: UserDataState.id,
        userName: UserDataState.userName,
        userEmail: UserDataState.userEmail,
        userToken: UserDataState.userToken,
        employeeId: UserDataState.employee_id,
        empId: UserDataState.empId,
        role_name: UserDataState.role_name,
        reporting_manager: UserDataState.reporting_manager
    };
});
export const companyDataSelector = createSelector([mainUserState], (UserDataState) => {
    return UserDataState.companyData;
});
export const refreshCalledSelector = createSelector([mainUserState], (UserDataState) => UserDataState.refreshCalled);
export const lastLoginPageSelector = createSelector([mainUserState], (userDataState) => userDataState.lastLoginPage);
export const wrongpassMessage = createSelector([mainUserState], (userDataState) => userDataState.message);
export const userPermissionsSelector = createSelector(
    [mainUserState],
    (UserDataState) => UserDataState.userPermissions || []
);
export const hasPermission = (state, code) => {
    const perms = state.UserData?.userPermissions || [];
    return perms.includes(code);
};

